export default "__VITE_ASSET__6fb94874__"